import React from 'react';
import { getOfferId } from '@nerdwallet/marketplace/selectors/common';
import { PRODUCT_TYPES } from '@nerdwallet/marketplace/constants';
import CreditCardSkittle from '../components/images/product-skittles/credit-card-skittle';
import PersonalLoanSkittle from '../components/images/product-skittles/personal-loans-skittle';
export var STATIC_PERSONAL_LOANS = "static_".concat(PRODUCT_TYPES.PERSONAL_LOANS);
/**
 * Returns the search label text according to product type.
 * @param productType
 */

export var getSearchLabel = function getSearchLabel(productType) {
  switch (productType) {
    case PRODUCT_TYPES.CREDIT_CARDS:
      return 'Enter the card you’d like to compare';

    case PRODUCT_TYPES.PERSONAL_LOANS:
      return "Enter the lender you'd like to compare";

    case STATIC_PERSONAL_LOANS:
      return 'Find a lender';

    default:
      return 'No custom label has been added for this product type';
  }
};
export var getSearchPlaceholder = function getSearchPlaceholder(productType) {
  switch (productType) {
    case PRODUCT_TYPES.CREDIT_CARDS:
      return undefined;

    case PRODUCT_TYPES.PERSONAL_LOANS:
      return 'Search lender name';

    case STATIC_PERSONAL_LOANS:
      return 'Lender name';

    default:
      return 'No custom placeholder has been added for this product type';
  }
};
/**
 * Returns the skittle icon to render based on the product type.
 * @param productType
 */

export var getSkittleIcon = function getSkittleIcon(productType, className) {
  switch (productType) {
    case PRODUCT_TYPES.CREDIT_CARDS:
      return /*#__PURE__*/React.createElement(CreditCardSkittle, {
        className: className
      });

    case STATIC_PERSONAL_LOANS:
    case PRODUCT_TYPES.PERSONAL_LOANS:
    case PRODUCT_TYPES.MORTGAGES:
      return /*#__PURE__*/React.createElement(PersonalLoanSkittle, {
        className: className
      });

    default:
      return 'No Provide a custom skittle icon for the product type';
  }
};
/**
 * Returns the empty state to render based on the product type.
 * @param productType
 */

export var getEmptyState = function getEmptyState(productType) {
  switch (productType) {
    case STATIC_PERSONAL_LOANS:
    case PRODUCT_TYPES.PERSONAL_LOANS:
      return {
        headerText: 'Select some loans to compare',
        bodyText: 'To see how your loan options stack up, pick 2 or more to compare side by side.',
        linkText: 'Go back'
      };

    case PRODUCT_TYPES.MORTGAGES:
      return {
        headerText: 'Compare quotes side-by-side',
        bodyText: 'The quotes you add to compare will appear here so you can easily evaluate them side-by-side.',
        linkText: 'Go back'
      };

    default:
      return {
        headerText: 'Empty State',
        bodyText: 'canEdit is false, and no card added to compare.',
        linkText: 'Go back link'
      };
  }
};
/**
 * Returns the unique id of the entity to compare on the product type.
 * @param marketplaceEntity
 * @param productType
 */

export var getUniqueEntityId = function getUniqueEntityId(marketplaceEntity, productType) {
  switch (productType) {
    case STATIC_PERSONAL_LOANS:
    case PRODUCT_TYPES.PERSONAL_LOANS:
      return marketplaceEntity === null || marketplaceEntity === void 0 ? void 0 : marketplaceEntity.uniqueId;

    case PRODUCT_TYPES.CREDIT_CARDS:
    default:
      return getOfferId(marketplaceEntity);
  }
};